import { REDUCER_NAME } from './constants'

export const rootSelector = (state) => state[REDUCER_NAME]
export const getRootInstance = (state, { type }) => state[REDUCER_NAME][type] || {}
export const getInstance = (state, { type, ID }) => getRootInstance(state, { type })[ID] || {}

export const isInstanceCreated = (state, { type, ID }) => state[type] && state[type][ID]

export const getActiveTab = (state, { type, ID }) => getInstance(state, { type, ID }).ui.activeTab
export const getAllActiveTabData = (state, { type, ID }) => getInstance(state, { type, ID }).data

export const getTabLoadingState = (state, { type, ID, page }) => {
  const instance = getInstance(state, { type, ID })

  if (Array.isArray(page)) {
    return page.some((p) => {
      if (!instance.ui) return true

      return instance.ui.loading[p]
    })
  }

  return instance.ui && instance.ui.loading[page]
}

export const getInfoPage = (state, { type, ID, page }) => {
  const instance = getInstance(state, { type, ID })

  if (Array.isArray(page)) {
    return page.reduce((result, route) => {
      const routeStr = typeof route === 'string' ? route : route.page
      if (instance.data) {
        result[routeStr] = instance.data[routeStr] // eslint-disable-line
      }

      return result
    }, {})
  }

  const pageStr = typeof page === 'string' ? page : page.page

  return instance.data && instance.data[pageStr]
}

export const getErrors = (state, { type, ID }) =>
  getInstance(state, { type, ID }).data && getInstance(state, { type, ID }).data.error

export const dataExistsOrIsBeingFetched = (state, { type, ID, page }) => {
  const isLoading = getTabLoadingState(state, { type, ID, page })
  const data = getInfoPage(state, { type, ID, page })

  return isLoading || data
}
